import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { Button, Typography } from '@material-ui/core';
import FormTextField from '../../form/FormTextField';
import FormRadioGroup from '../../form/FormRadioGroup';
import FormSelect from '../../form/FormSelect';
import { registrationFormValidation } from '../../../models/auth/AuthModelValidation';
import { ParticipantTypes } from '../../../models/auth/ParticipantTypes';
import ParticipantAddress from './ParticipantAddress';
import { ParticipantOrganizationTypes } from '../../../models/auth/ParticipantOrganizationTypes';
import FormCheckBoxWithLabel from '../../legacyForm/FormCheckBoxWithLabel';

const RegistrationForm = ({ t, onSubmit }) => {
  const organizationTypes = [
    { value: ParticipantOrganizationTypes.nonGovernment, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.nonGovernment}`) },
    { value: ParticipantOrganizationTypes.subordinate, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.subordinate}`) },
    { value: ParticipantOrganizationTypes.company, name: t(`auth.participantAccounts.participantOrganizationType.${ParticipantOrganizationTypes.company}`) },
  ];

  return (
    <Form
      onSubmit={onSubmit}
      validate={registrationFormValidation}
      render={({ handleSubmit, submitting, values }) => (
        <form onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom>Nowe konto użytkownika</Typography>
          <Typography gutterBottom variant="overline" component="div">Dane podstawowe</Typography>
          <div>
            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Email"
              placeholder="Twój email posłuży do logowania w systemie"
              fullWidth
              autoFocus
            />
          </div>
          <div>
            <Field
              name="firstName"
              component={FormTextField}
              label="Imię"
              fullWidth
            />
          </div>
          <div>
            <Field
              name="lastName"
              component={FormTextField}
              label="Nazwisko"
              fullWidth
            />
          </div>
          <div>
            <Field 
              name="password" 
              type="password" 
              component={FormTextField}
              label="Hasło"
              placeholder="Hasło musi zawierać co najmniej 8 znaków, w tym jedną cyfrę, wielką literę oraz znak specjalny"
              fullWidth
            />
          </div>
          
          <Typography variant="overline" component="div">Dane dodatkowe</Typography>
          <Typography variant="caption" component="div" gutterBottom color="textSecondary">Wprowadzenie informacji umożliwi weryfikację i potwierdzenie Twojej tożsamości</Typography>
          <div>
            <Field
              name="participantType"
              component={FormRadioGroup}
              values={[
                { value: '', name: 'Bez dodatkowych danych', subtitle: 'Konto nie podlega weryfikacji i umożliwia udział wyłącznie w konsultacjach otwartych' },
                { value: ParticipantTypes.naturalPerson, name: 'Osoba fizyczna', subtitle: 'Konto podlega weryfikacji i umożliwia udział w konsultacjach otwartych oraz dostępnych tylko dla osób zweryfikowanych' },
                { value: ParticipantTypes.legalEntity, name: 'Instytucja lub podmiot publiczny', subtitle: 'Konto podlega weryfikacji i umożliwia udział w konsultacjach otwartych oraz dostępnych wyłącznie dla osób zweryfikowanych, dla firm, dla jednostek podległych i organizacji pozarządowych' }
              ]}
            />
          </div>
          
          {values.participantType === ParticipantTypes.naturalPerson
          ? <React.Fragment>
            <div style={{ width: 300 }}>
              <Field
                name="naturalPersonData.pesel"
                component={FormTextField}
                label="Numer PESEL"
                fullWidth
              />
            </div>
            <ParticipantAddress fieldPrefix="naturalPersonData" />
          </React.Fragment>
          : values.participantType === ParticipantTypes.legalEntity ?
            <React.Fragment>
              <div>
                <Field
                  name="organizationType"
                  component={FormSelect}
                  label="Typ organizacji"
                  fullWidth
                  values={organizationTypes}
                />
              </div>
              <div>
                <Field
                  name="legalEntityData.name"
                  component={FormTextField}
                  label="Nazwa organizacji"
                  fullWidth
                />
              </div>
              <div style={{ width: 300 }}>
                <Field
                  name="legalEntityData.taxId"
                  component={FormTextField}
                  label="Numer NIP"
                  fullWidth
                />
              </div>
              <div style={{ width: 300 }}>
                <Field
                  name="legalEntityData.regon"
                  component={FormTextField}
                  label="Numer REGON"
                  fullWidth
                />
              </div>
              <div style={{ width: 300 }}>
                <Field
                  name="legalEntityData.krs"
                  component={FormTextField}
                  label="Numer KRS"
                  fullWidth
                />
              </div>
              <ParticipantAddress fieldPrefix="legalEntityData" />
            </React.Fragment>
          : null}
          <div>
            <Field
              name="consent1"
              component={FormCheckBoxWithLabel}
              label={<div>Akceptuję <a href="/regulamin" target="_blank" rel="noopener noreferrer">Regulamin</a>, żeby utworzyć i korzystać z konta konsultacji społecznych</div>}
              fullWidth              
            />
            <Field
              name="consent2"
              component={FormCheckBoxWithLabel}              
              label={<div>Wyrażam zgodę na przetwarzanie moich danych w konsultacjach społecznych. Zostałem poinformowany, że podanie danych jest dobrowolne a także, że w każdym czasie mogę odwołać udzieloną zgodę. <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">Pełna treść klauzuli informacyjnej</a></div>}
              fullWidth              
            />
            
          </div>

          <Button variant="contained" color="primary" type="submit" disabled={submitting} style={{ marginTop: 20 }}>
            {submitting ? t('auth.registration.registrationInProgressButton') : t('auth.registration.registrationButton')}
          </Button>
        </form>
      )}
    />
  );
};

RegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default translate()(RegistrationForm);



// WEBPACK FOOTER //
// ./src/components/auth/registration/RegistrationForm.js